interface Topic {
  label: string;
  count: string;
  hot: boolean;
}

const topics: Topic[] = [
  { label: '娱乐圈八卦', count: '2.3万', hot: true },
  { label: '网红塌房', count: '1.8万', hot: true },
  { label: '综艺翻车现场', count: '9,876', hot: true },
  { label: '明星恋情曝光', count: '8,432', hot: false },
  { label: '选角内幕', count: '7,654', hot: false },
  { label: '直播事故', count: '6,789', hot: false },
  { label: '品牌解约风波', count: '5,921', hot: true },
  { label: '私生饭追踪', count: '5,438', hot: false },
  { label: '影视剧争议', count: '4,872', hot: false },
  { label: '电竞圈爆料', count: '3,651', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            大家都在关注的话题标签，点击查看相关爆料
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}